// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  squadId: __t.u64().primaryKey().name("squad_id"),
  battleId: __t.u64().name("battle_id"),
  worldId: __t.u64().name("world_id"),
  side: __t.string(),
  index: __t.u32(),
  captainId: __t.u64().name("captain_id"),
  plan: __t.string(),
  updatedAt: __t.timestamp().name("updated_at"),
});
